import axios from 'axios';

const initialState = {
  isFormDataLoading: false,
  isFormDataLoaded: false,
  isSaveDataLoading: false,
  isLinkLoading: false,
  isSuccess: false,
  errorMessage: '',
  data: {
    businessName: '',
    customerCareContact: '',
    privacyPolicyText: '',
    privacyPolicyLink: '',
  },
  formURL: '',
};

export default {
  namespaced: true,
  state: { ...initialState },
  mutations: {
    setData(state, data) {
      state.data = {
        businessName: data.business_name,
        customerCareContact: data.customer_care,
        privacyPolicyText: data.privacy_policy_text,
        privacyPolicyLink: data.privacy_policy_url,
      };
    },
    setIsFormDataLoading(state, isFormDataLoading) {
      state.isFormDataLoading = isFormDataLoading;
    },
    setIsSaveDataLoading(state, isSaveDataLoading) {
      state.isSaveDataLoading = isSaveDataLoading;
    },
    isLinkLoading(state, isLoading) {
      state.isLoading = isLoading;
    },
    setFormURL(state, formURL) {
      state.formURL = formURL;
    },
    setIsFormDataLoaded(state, isFormDataLoaded) {
      state.isFormDataLoaded = isFormDataLoaded;
    },
  },
  actions: {
    async getData({ commit }) {
      commit('setIsFormDataLoaded', false);
      commit('setIsFormDataLoading', true);
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_COMMUNICATIONS_API_BASE_URL}/sms/opt-in/form/data`,
        );
        commit('setData', response.data);
        commit('setIsFormDataLoaded', true);
      } catch (error) {
        console.error(error);
      } finally {
        commit('setIsFormDataLoading', false);
      }
    },
    async saveData({ commit, state }, data) {
      commit('setIsSaveDataLoading', true);

      let payload = {};
      if (data.customerCareContact != state.data.customerCareContact) {
        payload.customer_care = data.customerCareContact;
      }

      if (data.privacyPolicyText != state.data.privacyPolicyText) {
        payload.privacy_policy_text = data.privacyPolicyText;
      }

      if (data.privacyPolicyLink != state.data.privacyPolicyLink) {
        payload.privacy_policy_url = data.privacyPolicyLink;
      }
       
      try {
        await axios.post(
          `${process.env.VUE_APP_COMMUNICATIONS_API_BASE_URL}/sms/opt-in/form/data`,
          payload,
        );
      } catch (error) {
        console.error(error);
      } finally {
        commit('setIsSaveDataLoading', false);
      }
    },
    async getOptInFormLink({ commit }) {
      commit('isLinkLoading', true);
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_COMMUNICATIONS_API_BASE_URL}/sms/opt-in/form/url`,
        );
        commit('setFormURL', response.data.url);
      } catch (error) {
        console.error(error);
      } finally {
        commit('isLinkLoading', false);
      }
    }
  },
};